import "../styles/Loader.css";

export const Loader = () => {
  return <div className="loader" data-testid="loader"></div>;
};

